import {gql} from 'apollo-angular';

export const UPDATE_LANGUAGE = gql`
  mutation updateLanguage($language: Language!) {
    updateLanguage(language: $language) {
      result
    }
  }
`;
